<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">Upload Approved Drawings and Documents</h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <!-- <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button> -->

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.can_edit">
          <button class="btn btn-primary me-2" (click)="routeConfig.emit({isRouteConfig: true})"
            >
            <i class="pi pi-save me-1"></i> Save/Forward/Route Config
          </button>
        </ng-container>


      </div>
    </div>
  </div>

  <hr class="my-3" />

   <div class=" mt-3 mb-4">
    <div *ngIf="stepDetails.can_edit"   class="d-flex justify-content-end"><button class="add-btn" (click)="addRow()">+ Add Row</button></div>
    <table class="custom-table table ">
      <thead><tr>
        <th class="bg-primary text-white py-2">Document</th>
        <th class="bg-primary text-white py-2">Submission Date</th>
        <th class="bg-primary text-white py-2">Approval Date</th>
        <th class="bg-primary text-white py-2">Remarks</th>
        <th *ngIf="stepDetails?.can_edit" class="bg-primary text-white py-2"  >Action</th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let row of rows; let i = index">
          <td><ng-container *ngIf="row.edit; else s"><input type="text" class="form-control" [(ngModel)]="row.document"/></ng-container><ng-template #s>{{row.document}}</ng-template></td>
          <td><ng-container *ngIf="row.edit; else v"><input type="date" class="form-control" [(ngModel)]="row.submission_date"/></ng-container><ng-template #v>{{row.submission_date}}</ng-template></td>
          <td><ng-container *ngIf="row.edit; else q"><input type="date" class="form-control" [(ngModel)]="row.approval_date"></ng-container><ng-template #q>{{row.approval_date}}</ng-template></td>
          <td><ng-container *ngIf="row.edit; else r"><textarea class="form-control" rows="2" [(ngModel)]="row.remark"></textarea></ng-container><ng-template #r>{{row.remark}}</ng-template></td>
          <td><ng-container *ngIf="stepDetails.can_edit">
            <button class="btn btn-sm btn-outline-primary me-1" *ngIf="!row.edit" (click)="row.edit=true">Edit</button>
            <button class="btn btn-sm btn-success" *ngIf="row.edit" (click)="saveRow(row); row.edit=false">Save</button>
          </ng-container></td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class=" mb-4">
    
    <app-upload-document [title]="stepDetails.name+' Document'" [isEditable]="stepDetails?.can_edit"> </app-upload-document>


    <form [formGroup]="commentForm">
      <div class="row">
          <div class="col-md-6 mb-3 pe-1 d-flex gap-2 my-5">
        <label class="bg-primary text-white  ">Final Date of Approved Documents<b class="text-warning">*</b></label>
        <input type="date" class="form-control" formControlName="date" [disabled]="isEditorDisabled" />
         </div>
          <div class="col-md-6 mb-3 pe-1 d-flex gap-2 my-5">
        <label class="bg-primary text-white  "> Delivery Date of Prototype System<b class="text-warning">*</b></label>
        <input type="date" class="form-control" formControlName="qap_date" [disabled]="isEditorDisabled" />
         </div>

      </div>
    
      <div class="editor-container" [class.readonly-editor]="isEditorDisabled">
        <p class="bg-primary text-white p-2 ">Comments <b class="text-warning">*</b>
        </p>

        <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
      </div>
    </form>
  </div>
</div>